import apiHandler from '../core/apiHandler';

const restaurantDiningRoomApi = apiHandler('restaurant/dining-rooms');

export default restaurantDiningRoomApi;
